import React from 'react';
import classNames from 'classnames';


var QED = function(options) {

    options = {hover:true, ...options}

    // Ugly, but QED.Header needs the sticky property
    QED.props = options;

    var {hover, border, sticky = true, style = {}, ...props} = options; 

    // Why ?!
    style = {...style};

    if (style == undefined)
        style = {};

    if (style.height != undefined) {
        sticky = true;
    }

    if (sticky) {
        style.overflowY = 'auto';

        //if (style.height == undefined)
          //  style.height = '15rem';
    }

    if (border) {
        style.border = 'var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)';
        style.borderRadius = 'var(--bs-border-radius)';
    }

    return QED.Tag({tag:'div', style:style, ...props});

}



QED.Header = function(props) {

    var {style = {}, ...props} = props;

    if (QED.props.sticky) {
        style.position = 'sticky';
        style.top = 0;

    }

    return QED.Tag({tag:'thead', style:style, ...props});
}  

QED.Tag = function(props) {

    var {tag:Tag, ...props} = props;

    return (
        <Tag {...props}/>
    );

}



QED.Table = function(props) {

    var {hover = QED.props.hover, responsive = true, style = {}, className, ...props} = props;

//    hover = true;

    className = classNames('table');
    className = classNames(className, hover ? 'table-hover' : null);
    className = classNames(className, responsive ? 'table-responsive' : null);

    if (style.cursor == undefined)
        style.cursor = 'default';
    
    return QED.Tag({tag:'table', ...props, style:style, className:className});
}



    
QED.Body = function(props) {

    return QED.Tag({tag:'tbody', ...props});
}




QED.Row = function(props) {

    var {cells, align = 'middle', color, selected, className, ...props} = props;

    if (align)
        className = classNames(className, `align-${align}`);

    if (color)
        className = classNames(className, `table-${color}`)

    if (selected)
        className = classNames(className, 'table-primary')

    let renderChildren = () => {
        if (cells == undefined)
            return props.children;
            
        return cells.map((cell, index) => {
            let {children, ...props} = cell;

            return QED.Cell({key:index, ...props});
        });
    };

    return QED.Tag({tag:'tr', ...props, className:className, children:renderChildren()});
}


QED.Columns = function(props) {

    return QED.Tag({tag:'tr', ...props});
}

QED.Column = function(options) {

    let {style = {}, className, align, ...props} = options;

    switch(align) {
        case 'left':
            className = classNames(className, 'text-start');
            break;
        case 'right':
            className = classNames(className, 'text-end');
            break;
        case 'center':
            className = classNames(className, 'text-center');
            break;
    }

    // Must have a backgroiund color if fixed header
    style.background = 'var(--bs-light)';
    
    return QED.Tag({tag:'th', style:style, className:className, ...props});

}

QED.Cell = function(props) {

    return QED.Tag({tag:'td', ...props});
}


export default QED;
